export abstract class IComponentEntitlementService {
    abstract hasRole(componentName: string, role: string): boolean;
}
